<ion-header class="betslip-unlocker--header">
  <img src="assets/global/img/logo.svg" />
</ion-header>
<ion-content [ngClass]="{'is-mobile': isMobile}">
  <div class="content betslip-unlocker">
    <ion-row class="betslip-unlocker--row">
      <ion-card class="betslip-unlocker--card">
        <ion-card-header>
          <ion-card-title>{{ "Attention" | translate}}</ion-card-title>
          <img src="assets/sports/img/sport-images/clean-cache-gon-g.svg" class="betslip-unlocker--image" />
          <ion-card-subtitle> {{ "SPO_BetslipUnlockerSubtitle" | translate }} </ion-card-subtitle>
        </ion-card-header>

        <ion-card-content> {{ "SPO_BetslipUnlockerMessage" | translate }} </ion-card-content>

        <ion-button (click)="clearAll()" class="btn-primary" size="large"
          >{{ 'SPO_BetslipUnlockerButtonText' | translate }}
        </ion-button>
      </ion-card>
    </ion-row>
  </div>
</ion-content>
